module.exports = __webpack_public_path__ + "static/media/header_album_asahi36898f2de1feca7bca35286ad48ae0f8.webp";